import { BehaviorSubject, Observable } from 'rxjs';

export function createBehaviorSubject<T>(initialValue: T, observable: Observable<T>) {
  const subj = new BehaviorSubject(initialValue);
  observable.subscribe(subj); // TODO: Destroy subscription on subject unsubscribe.

  return subj;
}


